/**
 * Big Waster API
 * This is a Big Waster API.
 *
 * OpenAPI spec version: 1.0
 * Contact: terry.wong@futureimpactlab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ShopOutputUserBalance model module.
 * @module model/ShopOutputUserBalance
 * @version 1.0
 */
class ShopOutputUserBalance {
    /**
     * Constructs a new <code>ShopOutputUserBalance</code>.
     * @alias module:model/ShopOutputUserBalance
     */
    constructor() { 
        
        ShopOutputUserBalance.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ShopOutputUserBalance</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ShopOutputUserBalance} obj Optional instance to populate.
     * @return {module:model/ShopOutputUserBalance} The populated <code>ShopOutputUserBalance</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ShopOutputUserBalance();

            if (data.hasOwnProperty('balance')) {
                obj['balance'] = ApiClient.convertToType(data['balance'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} balance
 */
ShopOutputUserBalance.prototype['balance'] = undefined;






export default ShopOutputUserBalance;

